import { render } from "./AdminShiftView.vue?vue&type=template&id=4e51de5e&scoped=true&ts=true&lang=true"
import script from "./AdminShiftView.vue?vue&type=script&lang=ts"
export * from "./AdminShiftView.vue?vue&type=script&lang=ts"

import "./AdminShiftView.vue?vue&type=style&index=0&id=4e51de5e&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e51de5e"]])

export default __exports__